<section class="dashboard-page">
  <header class="page-header">
    <div>
      <span class="eyebrow">Operations workspace</span>
      <h1>Dashboard</h1>
      <p>Select a module to view its records or open the reports summary.</p>
    </div>

    <button type="button" class="secondary-button" (click)="logout()">Logout</button>
  </header>

  <div class="tile-grid">
    <button
      type="button"
      class="tile-card"
      *ngFor="let tile of tiles"
      [style.--tile-accent]="tile.accent"
      (click)="openTile(tile)"
    >
      <span class="tile-meta">{{ getTileMeta(tile) }}</span>
      <h2>{{ tile.title }}</h2>
      <p>{{ tile.description }}</p>
    </button>
  </div>
</section>